import { useMemo } from "react";
import useEmployeeStoreState from "../EmployeeStoreState";
import { MODE_GRID } from "../slices/createLayoutSlice";

const useLayout = () => {
  const { showHomeProductsMode, showHomeAsGrid, showHomeAsList } =
    useEmployeeStoreState((state) => ({
      showHomeProductsMode: state.showHomeProductsMode,
      showHomeAsGrid: state.showHomeAsGrid,
      showHomeAsList: state.showHomeAsList,
    }));

  const isGridView = useMemo(() => {
    return showHomeProductsMode === MODE_GRID;
  }, [showHomeProductsMode]);

  return { showHomeProductsMode, isGridView, showHomeAsGrid, showHomeAsList };
};

export default useLayout;
